module.exports = __webpack_public_path__ + "img/chevron-down (2).11679de9.svg";